import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import { config } from "@/firebase/";
import firebaseui from "firebaseui";
import firebase from "firebase";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created() {
    firebase.initializeApp(config);
    firebase
      .firestore()
      .enablePersistence()
      .catch(function (err) {
        if (err.code == "failed-precondition") {
          console.log(err);
        } else if (err.code == "unimplemented") {
          console.log(err);
        }
      });
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch("init", user);

        const messaging = firebase.messaging();

        messaging.usePublicVapidKey(
          "BJ8NlX9ZetBNZikfQO6j2NCw2QSB2EHfFjEKMxF1cxeCr4gqSMrmXO5l6E83s7cMzGmQAQjJTxF2XswQp5F2b-g"
        ); // 1. Generate a new key pair

        // Request Permission of Notifications
        messaging
          .requestPermission()
          .then(() => {
            console.log("Notification permission granted.");
            // Get Token
            messaging.getToken().then(token => {
              console.log(token);
              firebase.firestore().collection('fcmTokens').doc(token)
                .set({ uid: firebase.auth().currentUser.uid });
            });
          })
          .catch(err => {
            console.log("Unable to get permission to notify.", err);
          });

        this.$router.push("/");
      } else {
        this.$router.push("/auth");
      }
    });

  },
  render: h => h(App)
}).$mount("#app");
